import React from 'react';
import { motion } from 'framer-motion';
export function Slide17Improvements() {
  const improvements = [{
    title: 'Keep the QR mechanic',
    desc: 'It worked and should remain part of the congress setup.'
  }, {
    title: 'Add iPads at the booth',
    desc: 'Do not rely only on attendees scanning. Let reps guide people directly into the experience.'
  }, {
    title: 'Give reps a simple script',
    desc: 'Use one consistent opening line: "We’re running a 60-second Radiopharma Pulse — want to see how your view compares with your peers?"'
  }, {
    title: 'Use pre-event teaser content',
    desc: 'Before the congress, use the SNMMI result as the hook: "At SNMMI, isotope supply came out as the leading bottleneck. What will [next congress] say?"'
  }, {
    title: 'Use rep-specific links',
    desc: 'Each rep should have their own link so Minerva can see who drives engagement and which conversations follow.'
  }, {
    title: 'Make the prize/booth incentive more visible',
    desc: 'Use the reward to drive booth traffic, but keep the experience framed around peer insight, not just the raffle.'
  }, {
    title: 'Create a post-event insight asset immediately',
    desc: 'Prepare the post-event asset before the congress so it can be sent within days, not weeks.'
  }];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-538">
      <div className="mb-10" data-id="element-539">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-540">
          How to improve the next congress activation
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-541">
          Keep what worked, but strengthen the activation layer around it. The
          next improvement is operational.
        </p>
      </div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-542">
        {improvements.map((imp, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2 + i * 0.08
      }} className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm flex gap-4" data-id="element-543">
            <div className="w-8 h-8 shrink-0 bg-minerva-blue/10 text-minerva-blue font-bold rounded-full flex items-center justify-center text-sm" data-id="element-544">
              {i + 1}
            </div>
            <div data-id="element-545">
              <h3 className="font-bold text-slate-800 mb-1" data-id="element-546">{imp.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-547">
                {imp.desc}
              </p>
            </div>
          </motion.div>)}
      </div>
    </div>;
}